module.exports = __webpack_public_path__ + "static/media/walkthrough_video_thumbnail.49b1e29b.png";